var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "staff-page" },
    [
      _vm._m(0),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.loadCurrent },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "职员", name: "staff" } }),
          _c("el-tab-pane", { attrs: { label: "权限组", name: "role" } }),
        ],
        1
      ),
      _c(
        "el-card",
        { attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "关键词" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearch($event)
                      },
                    },
                    model: {
                      value: _vm.searchForm.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchForm,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchForm.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.openCreate } }, [
                    _vm._v(
                      _vm._s(_vm.tab === "role" ? "新权限组" : "邀请职员")
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticClass: "table-card",
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _vm.tab === "staff"
            ? _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: { data: _vm.tableData.data, size: "mini" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "staff.staffNo",
                      label: "工号",
                      "min-width": "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "staff.name",
                      label: "姓名",
                      "min-width": "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "staff.jobType",
                      label: "岗位",
                      width: "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "staff.employmentStatus",
                      label: "任职",
                      width: "110",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "260" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return _vm._l(
                              (row.actions || []).filter(function (item) {
                                return item !== "revoke_role"
                              }),
                              function (action) {
                                return _c(
                                  "el-button",
                                  {
                                    key: action,
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.runAction(row, action)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.actionText(action)))]
                                )
                              }
                            )
                          },
                        },
                      ],
                      null,
                      false,
                      2771409448
                    ),
                  }),
                ],
                1
              )
            : _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: { data: _vm.tableData.data, size: "mini" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "role.roleCode",
                      label: "编码",
                      "min-width": "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "role.roleName",
                      label: "名称",
                      "min-width": "140",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "role.dataScope",
                      label: "范围",
                      width: "110",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "role.status", label: "状态", width: "100" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "220" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return _vm._l(row.actions, function (action) {
                            return _c(
                              "el-button",
                              {
                                key: action,
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.runAction(row, action)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.actionText(action)))]
                            )
                          })
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-size": _vm.searchForm.limit,
                  "current-page": _vm.searchForm.page,
                  layout: "total, prev, pager, next",
                  total: _vm.tableData.total,
                },
                on: {
                  "current-change": function (page) {
                    _vm.searchForm.page = page
                    _vm.loadCurrent()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hero" }, [
      _c("div", [
        _c("span", [_vm._v("STAFF & ROLE")]),
        _c("h2", [_vm._v("权限设置")]),
        _c("p", [
          _vm._v("邀请职员待激活，权限组绑定动作码后可授权给在职人员。"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }